import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteCompetitiveExamLessonMaster = () => {
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const initialFormState = {
        instituteMasterId: instituteMasterId,
        instituteCompetitiveExamNameMasterId: '',
        instituteCompetitiveExamBookMasterId: '',
        instituteSubjectMasterId: '',
        competitiveLessonName: ['']
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [bookList, setBookList] = useState([]);
    const [lessonData, setLessonData] = useState(initialFormState)
    const [lessonList, setLessonList] = useState([])
    const [editId, setEditId] = useState(null)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [examNameSort, setExamNameSort] = useState(null);
    const [bookNameSort, setBookNameSort] = useState(null);
    const [subjectNameSort, setSubjectNameSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["instituteCompetitiveExamNameMasterDetails.examName", "instituteCompetitiveExamBookMasterDetails.bookName", "instituteSubjectMasterDetails.subjectName", "competitiveLessonName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (lessonData.instituteCompetitiveExamBookMasterId !== '' && lessonData.instituteSubjectMasterId.length !== 0) {
            getLessonList();
        }
    }, [lessonData.instituteSubjectMasterId]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getLessonList();
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (lessonData.instituteCompetitiveExamBookMasterId.length !== 0 && lessonData.instituteSubjectMasterId.length !== 0) {
                setLessonList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(lessonList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(lessonList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > lessonList.length) {
            endIndex = lessonList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(lessonList.slice(startIndex, endIndex));
    }, [lessonList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = '/get-institute-competitive-lesson-master?';
        if (lessonData.instituteMasterId) {
            apiUrl += `instituteMasterId=${lessonData.instituteMasterId}&`;
        }
        if (lessonData.instituteSubjectMasterId) {
            apiUrl += `instituteSubjectMasterId=${lessonData.instituteSubjectMasterId}&`;
        }

        if (lessonData.instituteCompetitiveExamBookMasterId) {
            apiUrl += `instituteCompetitiveExamBookMasterId=${lessonData.instituteCompetitiveExamBookMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getLessonList = async () => {
        try {
            const response = await authorizedAxiosInstitute.get(getApiUrl())
            setLessonList(response.data.result);
        } catch (error) {
            setLessonList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-institute-competitive-exam-names?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        const { name, value } = e.target;
        setLessonData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                instituteCompetitiveExamBookMasterId: '',
                instituteSubjectMasterId: ''
            }
        })

        const apiUrl = `/get-institute-competitive-exam-book-master?instituteCompetitiveExamNameMasterId=${value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setBookList(response.data.data)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleBookChange = (e) => {
        setLessonData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubjectMasterId: ''
            }
        });

        const apiUrl = `/get-institute-competitive-exam-book-wise-subject?instituteCompetitiveExamBookMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        setLessonData((prevData) => {
            if (name === 'competitiveLessonName') {
                // Update the value at the specified index
                const updatedLessonName = [...prevData.competitiveLessonName];
                updatedLessonName[index] = value;
                return {
                    ...prevData,
                    competitiveLessonName: updatedLessonName,
                };
            } else {
                return {
                    ...prevData,
                    [name]: value
                }
            }
        })
    }

    const handleAddLesson = () => {
        setLessonData((prevData) => ({
            ...prevData,
            competitiveLessonName: [...prevData.competitiveLessonName, ''],
        }));
    };

    const handleRemoveLesson = (index) => {
        setLessonData((prevData) => {
            const updatedLessonName = [...prevData.competitiveLessonName];
            // Remove the element at the specified index
            updatedLessonName.splice(index, 1);
            return {
                ...prevData,
                competitiveLessonName: updatedLessonName,
            }
        });
    };

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(lessonData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(lessonData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [lessonData])

    const addLesson = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-institute-competitive-lesson-master`;
                const response = await authorizedAxiosInstitute.post(apiUrl, lessonData)
                await getLessonList();
                setLessonData((prevData) => {
                    return {
                        ...prevData,
                        competitiveLessonName: [''],
                    };
                })

                setSaveId(response.data.result[0].id); // check this
                setExamNameSort(null);
                setBookNameSort(null);
                setSubjectNameSort(null);
                setLessonNameSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(lessonData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteLesson = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-competitive-lesson-master?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl)
                const page = deleteItem(currPage, itemsPerPage, lessonList.length);
                await getLessonList();
                setCurrPage(page);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateLesson = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-institute-competitive-lesson-master?id=${editId}`;
            const response = await authorizedAxiosInstitute.put(apiUrl, { competitiveLessonName: lessonData?.competitiveLessonName[0] })
            await getLessonList();
            setEditId(null);
            setLessonData((prevData) => {
                return {
                    ...prevData,
                    competitiveLessonName: [''],
                };
            })
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (examNameSort == true || examNameSort == false) {
            setBookNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
        }
    }, [examNameSort])

    useEffect(() => {
        if (bookNameSort == true || bookNameSort == false) {
            setExamNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
        }
    }, [bookNameSort])

    useEffect(() => {
        if (subjectNameSort == true || subjectNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setLessonNameSort(null);
        }
    }, [subjectNameSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setSubjectNameSort(null);
        }
    }, [lessonNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Competitive Exam Lesson Master</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i>Competitive Exam Lesson Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam Structure :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteCompetitiveExamNameMasterId' onChange={handleSyllabusChange} value={lessonData.instituteCompetitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Competitive Exam Structure</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteCompetitiveExamNameMasterId && <p style={{ color: 'red' }}>{error.instituteCompetitiveExamNameMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteCompetitiveExamBookMasterId' onChange={handleBookChange} value={lessonData.instituteCompetitiveExamBookMasterId}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            bookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteCompetitiveExamBookMasterId && <p style={{ color: 'red' }}>{error.instituteCompetitiveExamBookMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleInputChange} value={lessonData.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {console.log("subject List", subjectList)}
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                console.log("syllabus", syllabus);
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}

                                                </div>


                                                {lessonData?.competitiveLessonName?.map((lesson, index) => (
                                                    <>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Lesson Name :</label>
                                                            <input type="text" className="form-control" id={`competitiveLessonName${index}`} name='competitiveLessonName' onChange={(e) => handleInputChange(e, index)} value={lesson} />
                                                            {error.competitiveLessonName && <p style={{ color: 'red' }}>{error.competitiveLessonName}</p>}

                                                        </div>
                                                        {lessonData.competitiveLessonName.length > 1 && (
                                                            <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                                <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveLesson(index)} ><i class="material-icons" style={{ fontSize: '20px' }} >delete</i></button>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                                {!editId && (
                                                    <div className="col-md-12 mt-4 mb-1">
                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ width: '233px' }} onClick={handleAddLesson}>+ Add Another Lesson Name</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addLesson}>Save</button>
                                                        }                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setLessonList([]); setSubjectList([]); setEditId(''); setLessonData(initialFormState) }}>Reset</button>

                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateLesson} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Exam Name
                                                                            <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"instituteCompetitiveExamNameMasterDetails.examName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Book Name
                                                                            <SortIcon sortState={bookNameSort} setSortState={setBookNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"instituteCompetitiveExamBookMasterDetails.bookName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectNameSort} setSortState={setSubjectNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"competitiveLessonName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson?.instituteCompetitiveExamNameMasterDetails?.examName}</td>
                                                                                        <td>{lesson?.instituteCompetitiveExamBookMasterDetails?.bookName}</td>
                                                                                        <td>{lesson?.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                        <td>{lesson.competitiveLessonName}</td>
                                                                                        <td>
                                                                                            <button className=" btn-outline-warning edit_icon" title='Coming Soon...' disabled type="button" onClick={() => {
                                                                                                setLessonData({
                                                                                                    instituteCompetitiveExamNameMasterId: lesson?.instituteCompetitiveExamNameMasterDetails?.id,
                                                                                                    instituteCompetitiveExamBookMasterId: lesson?.instituteCompetitiveExamBookMasterDetails?.id,
                                                                                                    competitiveLessonName: [lesson.competitiveLessonName],
                                                                                                    instituteSubjectMasterId: lesson?.instituteSubjectMasterDetails?.id,
                                                                                                });
                                                                                                setEditId(lesson.id);
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn-outline-danger delete_icon" title='Coming Soon...' disabled type="button" /*disabled={editId === lesson.id}*/ onClick={() => deleteLesson(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Lesson Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={lessonList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteCompetitiveExamLessonMaster;